export const regexEmail = /^[a-zA-Z0-9+._%'-]{1,64}@[a-zA-Z0-9][a-zA-Z0-9-]{0,63}(\.[a-zA-Z0-9][a-zA-Z0-9-]{1,25})+$/;

/** Web addresses as people type them, so the scheme is optional and a path, query or fragment may follow. */
export const regexUrl = /^(https?:\/\/)?([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(?::\d{1,5})?(?:[/?#]\S*)?$/i;
